import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { page } from '/@/core/tracking/api'
import { __api as coreLoadingApi } from '/@/core/elements/loading'
import { getRoutes } from './routes'
import DesignerRootPage from './DesignerRoot.vue'
import {
  ViziRedirect,
  ProjectRedirect,
  PaletteRedirect,
  PortfolioRedirect,
  CompleteClass,
  HelpHubRedirect,
  CommunityRedirect,
} from './redirects'
import { isSm } from '/@/utils/responsive'
import { sendBeaconPageViewed } from '/@/utils/helpscout'
import { stellaModal } from '../stella/StellaModal'

export async function create() {
  const routes = await getRoutes({
    redirects: {
      ViziRedirect,
      ProjectRedirect,
      PaletteRedirect,
      PortfolioRedirect,
      CompleteClass,
      HelpHubRedirect,
      CommunityRedirect,
    },
    DesignerRootPage,
    isSm: isSm(),
  })
  const router = createRouter({
    history: createWebHistory(),
    routes: import.meta.hot ? [] : (routes as RouteRecordRaw[]),
    scrollBehavior() {
      // always scroll to top
      return { top: 0 }
    },
  })

  // (dev) hot reloading routes if ./routes.ts is modified
  if (import.meta.hot) {
    let removeRoutes = [] as Array<() => void>

    for (const route of routes) {
      removeRoutes.push(router.addRoute(route as RouteRecordRaw))
    }

    import.meta.hot!.accept('./routes', newRoutes => {
      if (!newRoutes) return
      for (const removeRoute of removeRoutes) removeRoute()
      removeRoutes = []
      for (const route of newRoutes.default) {
        removeRoutes.push(router.addRoute(route))
      }
      router.replace('')
    })
  }
  router.beforeEach(() => {
    coreLoadingApi.show({ delay: 100 })
  })
  router.afterEach((to, from) => {
    coreLoadingApi.hide()
    // closing any modal on route navigation
    stellaModal.close()

    if (to.meta?.noAnalytics) return

    setTimeout(() => {
      page(to, from)
      sendBeaconPageViewed(document.location.href, to.meta?.pageName || '')
    })
  })

  return router
}
